__turbopack_context__.v({
  "bottom-left": "STPopover-module__-GY16W__bottom-left",
  "bottom-right": "STPopover-module__-GY16W__bottom-right",
  "content": "STPopover-module__-GY16W__content",
  "popoverWrapper": "STPopover-module__-GY16W__popoverWrapper",
  "top-left": "STPopover-module__-GY16W__top-left",
  "top-right": "STPopover-module__-GY16W__top-right",
});
